import {Injectable, inject} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {mergeMap, tap} from 'rxjs';
import {MasterDataService} from '../../services';
import * as actions from './master-data.actions';

@State<void>({name: 'masterData'})
@Injectable({providedIn: 'root'})
export class MasterDataState {
    masterDataService = inject(MasterDataService);

    @Action(actions.CreateMasterData)
    create({dispatch}: StateContext<void>, {masterData}: actions.CreateMasterData) {
        return this.masterDataService
            .post(masterData)
            .pipe(mergeMap(data => dispatch(new actions.GetMasterDataResponse(data))));
    }

    @Action(actions.UpdateMasterData)
    update({dispatch}: StateContext<void>, {masterData}: actions.UpdateMasterData) {
        return this.masterDataService
            .patch(masterData)
            .pipe(mergeMap(data => dispatch(new actions.GetMasterDataResponse(data))));
    }

    @Action(actions.ActivateMasterData)
    activate({dispatch}: StateContext<void>, {masterData}: actions.ActivateMasterData) {
        return this.masterDataService
            .activate(masterData)
            .pipe(tap(data => dispatch(new actions.GetMasterDataResponse(data))));
    }

    @Action(actions.DeleteMasterData)
    delete(context: StateContext<void>, {masterData}: actions.DeleteMasterData) {
        return this.masterDataService.delete(masterData._id);
    }

    @Action(actions.RestoreMasterData)
    restore(context: StateContext<void>, {masterData}: actions.RestoreMasterData) {
        return this.masterDataService.restore(masterData._id);
    }

    @Action(actions.GetMasterData)
    getOne({dispatch}: StateContext<void>, {id}: actions.GetMasterData) {
        return this.masterDataService.getOne(id).pipe(tap(data => dispatch(new actions.GetMasterDataResponse(data))));
    }

    @Action(actions.SearchMasterDatas)
    get({dispatch}: StateContext<void>, {data}: actions.SearchMasterDatas) {
        let obs = null;
        if (data.condition) obs = this.masterDataService.search(data);
        else obs = this.masterDataService.get(data);

        return obs.pipe(tap(data => dispatch(new actions.GetMasterDatasResponse(data, {state: 'success'}))));
    }

    @Action(actions.UpdateMasterDataValue)
    updateMasterDataValue(ctx: StateContext<void>, {masterDataId, value}: actions.UpdateMasterDataValue) {
        return this.masterDataService.updateMasterDataValue(masterDataId, value);
    }

    @Action(actions.DeleteMasterDataValue)
    deleteMasterDataValue(ctx: StateContext<void>, {masterDataId, value}: actions.DeleteMasterDataValue) {
        return this.masterDataService.deleteMasterDataValue(masterDataId, value);
    }

    @Action(actions.CreateMasterDataValue)
    crateMasterDataValue(ctx: StateContext<void>, {masterDataId, value}: actions.CreateMasterDataValue) {
        return this.masterDataService.createMasterDataValue(masterDataId, value);
    }
}
